import React, { useCallback, useState } from "react";
import SwipeableViews from "react-swipeable-views";
import Pagination from "../Pagination";

const TopImagesSlider = ({ photoUrls}) => {
  const [photoIndex, setPhotoIndex] = useState(0);

  const handleChangeIndex = useCallback(
    (i) => {
      setPhotoIndex(i);
    },
    [setPhotoIndex]
  );

  return (
    <React.Fragment>
      <SwipeableViews
        enableMouseEvents
        index={photoIndex}
        onChangeIndex={(i) => handleChangeIndex(i)}
      >
        {photoUrls.length > 0 &&
          photoUrls.map((url, idx) => (
            <figure key={idx} className="adjust-box adjust-box-1x1 mb-0">
              <img
                data-src={url}
                alt="MembershipsImage"
                className="adjust-box-inner lazyload w-100 object-fit-cover"
              />
            </figure>
          ))
        }
      </SwipeableViews>
      <Pagination
        dots={photoUrls.length > 1 ? photoUrls.length : 0}
        index={photoIndex}
        onChangeIndex={(i) => handleChangeIndex(i)}
      />
    </React.Fragment>
  );
};

export default TopImagesSlider;